"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _designTokens = require("@decisiv/design-tokens");

var _ChevronDown = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronDown"));

var _ChevronUp = _interopRequireDefault(require("@decisiv/iconix/lib/components/ChevronUp"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _styleModifiers = require("../../utils/styleModifiers");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _Button = _interopRequireDefault(require("../Button"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Tag = _interopRequireDefault(require("../Tag"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TargetContainer = _styledComponents.default.div.withConfig({
  displayName: "Target__TargetContainer",
  componentId: "sc-1obpsql-0"
})(["align-items:center;display:flex;flex-wrap:wrap;justify-content:flex-start;width:100%;padding-right:15px;", ""], (0, _styleModifiers.when)('hasExpandIndicator', (0, _styledComponents.css)(["padding-right:45px;"])));

var Input = _styledComponents.default.input.withConfig({
  displayName: "Target__Input",
  componentId: "sc-1obpsql-1"
})(["font-family:", ";font-size:", ";font-weight:", ";overflow:visible;&::-moz-focus-inner{border:0;padding:0;margin:0;}background-color:inherit;border:transparent;display:block;line-height:140%;padding:0 10px 5px 1px;flex-grow:100;&:active,&:focus{outline:none;}"], _designTokens.typography.typeface.default, (0, _rem.default)(_designTokens.typography.size.alias.default), _designTokens.typography.weight.alias.default);

var ClearButtonContainer = (0, _styledComponents.default)(_Flex.default).withConfig({
  displayName: "Target__ClearButtonContainer",
  componentId: "sc-1obpsql-2"
})(["position:absolute;bottom:0;right:0;padding-bottom:2px;padding-left:10px;padding-right:10px;", ""], (0, _styleModifiers.when)('hasExpandIndicator', (0, _styledComponents.css)(["right:20px;"])));
var ExpandedIndicatorContainer = (0, _styledComponents.default)(_Flex.default).attrs({
  alignItems: 'center'
}).withConfig({
  displayName: "Target__ExpandedIndicatorContainer",
  componentId: "sc-1obpsql-3"
})(["position:absolute;bottom:2px;right:10px;color:", ";&:hover{color:", ";}", ";"], (0, _toColorString.default)(_color.default.interaction.pacificOcean), (0, _toColorString.default)(_color.default.interaction.indianOcean), (0, _styleModifiers.when)('disabled', (0, _styledComponents.css)(["color:", ";&:hover{color:", ";}"], (0, _toColorString.default)(_color.default.opacity.charcoal40), (0, _toColorString.default)(_color.default.opacity.charcoal40))));

function Target(_ref, ref) {
  var clearButtonLabel = _ref.clearButtonLabel,
      disabled = _ref.disabled,
      hasClearButton = _ref.hasClearButton,
      inputFieldLabel = _ref.inputFieldLabel,
      isPopoverVisible = _ref.isPopoverVisible,
      onClear = _ref.onClear,
      multiple = _ref.multiple,
      selectedValues = _ref.selectedValues,
      removeSelected = _ref.removeSelected,
      readOnly = _ref.readOnly,
      variant = _ref.variant,
      toggleIsPopoverVisible = _ref.toggleIsPopoverVisible,
      autoComplete = _ref.autoComplete,
      rest = _objectWithoutProperties(_ref, ["clearButtonLabel", "disabled", "hasClearButton", "inputFieldLabel", "isPopoverVisible", "onClear", "multiple", "selectedValues", "removeSelected", "readOnly", "variant", "toggleIsPopoverVisible", "autoComplete"]);

  var translate = (0, _useTranslations.default)();
  var hasExpandIndicator = !readOnly && variant === 'sync';
  return _react.default.createElement(TargetContainer, {
    hasExpandIndicator: hasExpandIndicator
  }, multiple && selectedValues && selectedValues.map(function (_ref2) {
    var id = _ref2.id,
        label = _ref2.label;
    return _react.default.createElement(_Tag.default, {
      key: id,
      text: label,
      style: {
        margin: '2px'
      },
      action: function action(e) {
        e.preventDefault();
        e.stopPropagation();
        removeSelected(id);
      },
      color: 'licoriceMousse',
      actionIntent: "danger",
      actionIcon: _Times.default,
      actionAttributes: {
        'aria-label': 'Delete'
      }
    });
  }), _react.default.createElement(Input, _extends({
    autoComplete: autoComplete || 'off',
    disabled: disabled,
    ref: ref
  }, rest)), hasClearButton && !readOnly && _react.default.createElement(ClearButtonContainer, {
    hasExpandIndicator: hasExpandIndicator
  }, _react.default.createElement(_Button.default, {
    style: {
      padding: 0
    },
    "aria-label": translate(clearButtonLabel, 'combobox.clearButtonLabel', {
      label: inputFieldLabel
    }),
    disabled: disabled,
    icon: _Times.default,
    intent: "danger",
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (!disabled && onClear) {
        onClear();
      }
    },
    size: "small",
    variant: "ghost"
  })), hasExpandIndicator && _react.default.createElement(ExpandedIndicatorContainer, {
    disabled: disabled
  }, _react.default.createElement(_Button.default, {
    disabled: disabled,
    style: {
      padding: 0
    },
    variant: "ghost",
    size: "small",
    tabIndex: -1,
    icon: isPopoverVisible ? _ChevronUp.default : _ChevronDown.default,
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      toggleIsPopoverVisible();
    }
  })));
}

var TargetWithRef = (0, _react.forwardRef)(Target);
TargetWithRef.displayName = 'SelectTarget';
var _default = TargetWithRef;
exports.default = _default;